/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  logger
 */

import { createLoggerInterface } from '@zcode/logger'

export const { logger, setLogger, setLogLevel } = createLoggerInterface()
